import React, {useState, useEffect, useRef} from "react";
import ReactPaginate from 'react-paginate';
import ModernPagination from './ModernPagination';




	
export default function PaginatedItems({ itemsPerPage, arrayOfDataToDisplay, Template }) {

    const [currentItems, setCurrentItems] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0);



    useEffect(() => {
    	if(arrayOfDataToDisplay.length > 0){
	    	let items = [...arrayOfDataToDisplay];

		    // Fetch items from another resources.
		    const endOffset = itemOffset + itemsPerPage;
		    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
		    setCurrentItems(items.slice(itemOffset, endOffset));
		    setPageCount(Math.ceil(items.length / itemsPerPage));
		}
	  }, [arrayOfDataToDisplay, itemOffset, itemsPerPage]);




	  // Invoke when user click to request another page.
	  const handlePageClick = (event) => {
	    const newOffset = (event.selected * itemsPerPage) % arrayOfDataToDisplay.length;
	    // console.log(
	    //   `User requested page number ${event.selected}, which is offset ${newOffset}`
	    // );
	    setItemOffset(newOffset);
	  };

  	return (
	    <>
	      <Template currentItems={currentItems} />
	      {pageCount > 1 && (
	        <ModernPagination
	          currentPage={Math.floor(itemOffset / itemsPerPage)}
	          totalPages={pageCount}
	          onPageChange={(selectedPage) => {
	            const newOffset = (selectedPage * itemsPerPage) % arrayOfDataToDisplay.length;
	            setItemOffset(newOffset);
	          }}
	          maxVisiblePages={5}
	          showFirstLast={true}
	        />
	      )}
	    </>
  	);


}